import React from 'react';
import ProductCard from '../ProductCard/ProductCard';
import SkeletonReservationArea from '../Skeletons/SkeletonReservationArea';

const TicketSelector = ({
  products,
  handleIncrement,
  handleDecrement,
  setSelectedProduct,
  toggleModal,
  loading,
  loadingImage,
  setLoadingImage,
}) => {
  const onInfoClick = (id) => {
    setSelectedProduct(id);
    toggleModal();
  };

  return (
    <div>
      {loading ? (
        SkeletonReservationArea()
      ) : (
        <>
          {products.map((p, index) => {
            return (
              <ProductCard
                key={index}
                product={p}
                handleIncrement={() => handleIncrement(p.id)}
                handleDecrement={() => handleDecrement(p.id)}
                hasMoreInfo={true}
                onInfoClick={() => {
                  onInfoClick(p);
                }}
                loadingImage={loadingImage}
                setLoadingImage={setLoadingImage}
              />
            );
          })}
        </>
      )}
    </div>
  );
};

export default TicketSelector;
